import ColumnTypes from '@/utils/ColumnTypes';

function getColums(that){
    let arr = [
        {
            label: '',
            width: 50,
            type: () => import('./tableCells/radioCell.vue'),
        },
        {
            label: '用户名称',
            minWdth: 200,
            type: () => import('./tableCells/nickNameCell.vue'),
        },
        {
            key:'mobile',
            label: '手机号',
            width: 150,
            type: ColumnTypes.TextCell
        },
        {
            key:'deptName',
            label: '部门',
            width: 180,
            type: ColumnTypes.TextCell
        },
        {
            label: '用户角色',
            width: 200,
            type: () => import('./tableCells/userCell.vue'),
        }
    ];
    return arr
}
export default getColums;